
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights/business-class",
      function () {
        return require("private-next-pages/flights/business-class.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flights/business-class"])
      });
    }
  